import dayjs from 'dayjs';
import { Link, useLocation } from 'react-router-dom';
import {
  Fixed2,
  formatAmountAbs,
  formatNumber,
} from '../../../common/utils/common.utils';
import { IWeeklyMonthlyDailyMonthly } from '../interfaces/dashboard.interfaces';
import DashboardTitle from './DashboardTitle';
import { getColor } from './MonthlyReport';

type Props = {
  data: IWeeklyMonthlyDailyMonthly | undefined;
  isDarkMode: any;
};

const YearlyReport = ({ data, isDarkMode }: Props) => {
  const from_date = dayjs().startOf('year').format('YYYY-MM-DD');
  const to_date = dayjs().format('YYYY-MM-DD');
  const location = useLocation();

  const yearly_summary = data?.yearlySalesInfo;

  const profit_loss = Math.round(
    Fixed2(yearly_summary?.sales) +
      Fixed2(yearly_summary?.service_charge) -
      Fixed2(yearly_summary?.discount) -
      Fixed2(yearly_summary?.purchase)
  );

  const reportData = [
    {
      label: 'Sales',
      name: 'Sales Amount',
      value: formatNumber(yearly_summary?.sales),
      url: `/reports/daily_sales_report?y_from_date=${from_date}&y_to_date=${to_date}`,
    },
    {
      label: 'Collection',
      name: 'Collection Amount',
      value: formatNumber(yearly_summary?.collection),
      url: `/reports/collection-report?from_date=${from_date}&to_date=${to_date}`,
    },

    {
      label: 'Discount',
      name: 'Discount Amount',
      value: formatNumber(yearly_summary?.discount),
      url: `/reports/head_wise_expense_report?y_from_date=${from_date}&y_to_date=${to_date}`,
    },

    {
      label: 'Purchased',
      name: 'Purchased Amount',
      value: formatNumber(yearly_summary?.purchase),
      url: `/reports/vendor_wise_purchase_and_payment?y_from_date=${from_date}&y_to_date=${to_date}`,
    },
    {
      label: 'Payment',
      name: 'Payment Amount',
      value: formatNumber(yearly_summary?.payment),
      url: `/vendors/payment?y_from_date=${from_date}&y_to_date=${to_date}`,
    },

    {
      label: 'Profit',
      name: profit_loss > 0 ? 'Profit' : 'Loss',
      value: formatAmountAbs(profit_loss),
      url: `/reports/over_all_profit_loss?y_from_date=${from_date}&y_to_date=${to_date}`,
    },
  ];

  return (
    <div className="dashboard-box-shape">
      <DashboardTitle
        title="YEARLY SALES REPORT"
        linkTitle="View Overall"
        link={`/reports/over_all_profit_loss?y_from_date=${from_date}&y_to_date=${to_date}`}
      />
      <div style={{ padding: '0px 20px 10px' }}>
        {reportData?.map((item: any, index: number) => (
          <div
            className={`${isDarkMode ? 'report_box-dark' : ''} report_box${
              index === reportData?.length - 1 ? ' last_box' : ''
            }`}
            key={index}
          >
            <Link
              state={location.pathname}
              to={item.url}
              className="hover_effect"
              style={getColor(index)}
            >
              {item.name}
            </Link>
            <p>{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default YearlyReport;
